/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_TitleInputs */

const en_mk_tb_title = /** @type {(inputs: Mk_Tb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your team. Your own AI. One view of the work.`)
};

const id_mk_tb_title = /** @type {(inputs: Mk_Tb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu tim. AI masing-masing. Progres terlihat bersama.`)
};

/**
* | output |
* | --- |
* | "Your team. Your own AI. One view of the work." |
*
* @param {Mk_Tb_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_title = /** @type {((inputs?: Mk_Tb_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_title(inputs)
	return en_mk_tb_title(inputs)
});